document.addEventListener("DOMContentLoaded", () => {

    // get elements
    const showMoreEventsBtn = document.querySelector(".showMoreEvents_btn");
    const allEvents = document.querySelectorAll('.event');

    // hide members by default
    allEvents.forEach( (thisEvent) => {
        thisEvent.classList.add('hidden');
    })


    // show the first 3 three
    showFirstFewEvents();

    // make show more work
    showMoreEventsBtn.addEventListener('click', toggleShowAll);

})

function showFirstFewEvents(){

    const events = document.querySelectorAll('.event');
    const nrEvents = events.length;

    // only show first few events on load
    if( nrEvents > 4) {

        // only show the first few events
        for(var i=0; i < 4; i++)
        {
            events[i].classList.add('firstshown');
            events[i].classList.remove('hidden');
        }

    } else if (nrEvents === 0) {


        // hide the "show more" button
        hideShowMoreButton();

        // show text
        const agendaTitle = document.querySelector('.agendaSubTitle');
        if( agendaTitle ) {
            agendaTitle.insertAdjacentHTML('afterend', "<br/><p style='text-align: center;'>Zur Zeit sind keine Events geplant. Kommen sie bald wieder!</p>");
        }

    } else {

        // show all events
        events.forEach( (event) => {
            event.classList.add('firstshown');
            event.classList.remove('hidden');
        })

        // hide the "show more" button
        hideShowMoreButton();
    }

}


function hideShowMoreButton() {
    const eventBtn =  document.querySelector('.showMoreEvents_btn');
    const emptyBtnPadding =  document.querySelector('.eventButton');

    if (eventBtn) {
       eventBtn.style.display = 'none';
    }

    if (emptyBtnPadding) {
        emptyBtnPadding.classList.add('bottomPadding');
    }
}


function toggleShowAll() {
    const events = document.querySelector('.events');
    const showAllStatus = events.dataset.showAll;
    const showMoreEventsBtn = document.querySelector(".showMoreEvents_btn");

    // get team members
    if( showAllStatus == "false") {
        const allEvents = document.querySelectorAll('.event');
        allEvents.forEach( (thisEvent) => {
            thisEvent.classList.remove('hidden');
        })
        events.dataset.showAll = "true";
        showMoreEventsBtn.innerText = "weniger Veranstaltungen anzeigen";

    } else {
        const allEvents = document.querySelectorAll('.event');
        allEvents.forEach( (thisEvent) => {
            if(!thisEvent.classList.contains('firstshown')) {
                thisEvent.classList.add('hidden');
            }
        })
        events.dataset.showAll = "false";
        showMoreEventsBtn.innerText = "weitere Veranstaltungen anzeigen";

        // scroll back to the top of team
        scrollToElement(events);
    }
}


function scrollToElement(element){
    var offset = 50;
    var elementPosition = element.offsetTop;
    var offsetPosition = elementPosition - offset;

    window.scrollTo({
         top: offsetPosition,
         behavior: "smooth"
    });
}